<template>
    <div class="biz-menu-mb">
        <img class="logo" src="@/assets/img/flypig.svg" alt="">
        <ul>
            <li  v-for="(list, index) in menuFilter" :key="index" @mouseenter="mouseEvent(index, true)" @mouseleave.stop="mouseEvent(index, false)">
                <div class="main-title"  >
                    <img class="list-icon" :src="list.img.now" alt="">
                    <span v-if="list.hasTodo" class="todo-dot"></span>
                    <!-- <span class="list-title">{{list.title}}</span> -->
                    <!-- <img class="list-arrow" :class="{'close': !list.subDisplay}" src="@/assets/img/icon/arrow_down_gray.svg" alt=""> -->
                </div>
                <transition  name="fade"> 
                    <ul ref="sub-list-item" v-if="list.subDisplay">
                        <div class="sub-title">{{list.title}}</div>
                        <li v-for="(subList, subListIndex) in list.children" :key="subListIndex" v-show="subList.display">
                            <router-link v-if="subList.linkName" :to="{name: subList.linkName}">
                                {{subList.title}}
                            </router-link>
                            <span v-else>
                                {{subList.title}}
                            </span>
                            <span class="todo-count" v-if="subList.todo">{{subList.todo}}</span>
                        </li>
                    </ul>
                </transition> 
            </li>
        </ul>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
    name: 'Menu',
    data () {
        return {
            componentKey: 0
        }
    },
    methods: {
        mouseEvent: function (index, status) {
            let nav = document.getElementsByClassName('bussiness-nav')[0]
            this.componentKey += 1
            this.menuFilter[index].subDisplay = status
            
            if(status === false){
                nav.style.zIndex = 1
            }else{
                nav.style.zIndex = 9
            }
        }
    },
    computed: {
        menuList: function () {
            return  [
                {
                    linkName: 'housestatusdefault',
                    img:{
                        now: require('@/assets/img/component/bizMenu/home.svg'),
                        default: require('@/assets/img/component/bizMenu/home.svg'),
                        hover: require('@/assets/img/component/bizMenu/home.svg')
                    },
                    title: '個人首頁',
                    subDisplay: false,
                    children: [
                        {
                            linkName: 'bizHomeDefault',
                            title: '我的首頁',
                            display: true
                        },
                        {
                            linkName: 'bizTodoListDefault',
                            title: '待辦事項',
                            display: true
                        },
                        {
                            linkName: 'bizRecommandTenant',
                            title: '推薦房客',
                            display: true
                        }
                    ]
                },
                // {
                //     linkName: 'HouseManagementDefault',
                //     img:{
                //         now: require('@/assets/img/component/bizMenu/function.svg'),
                //         default: require('@/assets/img/component/bizMenu/function.svg'),
                //         hover: require('@/assets/img/component/bizMenu/function.svg')
                //     },
                //     title: '功能一覽',
                //     subDisplay: true,
                // },
                {
                    linkName: 'BookingManagementdefault',
                    img:{
                        now: require('@/assets/img/component/bizMenu/management.svg'),
                        default: require('@/assets/img/component/bizMenu/management.svg'),
                        hover: require('@/assets/img/component/bizMenu/management.svg')
                    },
                    title: '管理分類',
                    subDisplay: false,
                    hasTodo: this.hasTodo,
                    children: [
                        {
                            linkName: 'bizHouseMgtDefault',
                            title: '房源管理',
                            display: this.bizAuth?this.bizAuth.viewHouse.hasRight:false,
                            todo: this.todoHouseCount
                        },
                        {
                            linkName: 'bizHouseGroupMgtDefault',
                            title: '房源群組',
                            display: this.bizAuth?this.bizAuth.viewHouseGroup.hasRight:false,
                        },
                        {
                            linkName: 'bizBookingMgtDefault',
                            title: '預定管理',
                            display: this.bizAuth?this.bizAuth.viewBooking.hasRight:false,
                            todo: this.todoBookingCount
                        },
                        {
                            linkName: 'bizLeaseMgtDefault',
                            title: '租約管理',
                            display: this.bizAuth?this.bizAuth.viewContract.hasRight:false,
                            todo: this.todoContractCount
                        },
                        {
                            linkName: 'bizTaskMgtDefault',
                            title: '委託房客',
                            display: this.bizAuth?this.bizAuth.viewTask.hasRight:false,
                            todo: this.todoTaskCount
                        },
                        // {
                        //     linkName: '',
                        //     title: '房客管理',
                        // },
                        {
                            linkName: 'bizLandlordMgtDefault',
                            title: '屋主管理',
                            display: this.bizAuth?this.bizAuth.viewLandlord.hasRight:false
                        },
                        // {
                        //     linkName: '',
                        //     title: '評價管理',
                        // }
                    ]
                },
                {
                    linkName: 'leasemanagementdefault',
                    img:{
                        now: require('@/assets/img/component/bizMenu/finance.svg'),
                        default: require('@/assets/img/component/bizMenu/finance.svg'),
                        hover: require('@/assets/img/component/bizMenu/finance.svg')
                    },
                    title: '財務報表',
                    subDisplay: false,
                    children: [
                        {
                            linkName: 'bizReportOverview',
                            title: '報表概覽',
                            display: this.bizAuth?this.bizAuth.viewReport.hasRight:false
                        },
                        {
                            linkName: 'billMgt',
                            title: '帳單管理',
                            display: this.bizAuth?this.bizAuth.viewBill.hasRight:false
                        },
                        {
                            linkName: 'ledgerMgt',
                            title: '記帳管理',
                            display: this.bizAuth?this.bizAuth.viewLedger.hasRight:false
                        },
                        {
                            linkName: 'landlordReport',
                            title: '屋主報表',
                            display: this.bizAuth?this.bizAuth.landlordBillStatement.hasRight:false
                        },
                    ]
                },
                {
                    linkName: 'tenantManagementDefault',
                    img:{
                        now: require('@/assets/img/component/bizMenu/company.svg'),
                        default: require('@/assets/img/component/bizMenu/company.svg'),
                        hover: require('@/assets/img/component/bizMenu/company.svg')
                    },
                    title: '內部權限',
                    subDisplay: false,
                    children: [
                        {
                            linkName: 'bizEmployeeRole',
                            title: '職務部門',
                            display: this.bizAuth?this.bizAuth.viewRole.hasRight:false
                        },
                        {
                            linkName: 'bizOrganizationGroup',
                            title: '業務分群',
                            display: this.bizAuth?this.bizAuth.viewGroup.hasRight:false
                        },
                        {
                            linkName: 'bizAccountMgt',
                            title: '員工帳號',
                            display: this.bizAuth?this.bizAuth.viewUser.hasRight:false
                        },
                    ]
                },
                {
                    linkName: 'financialManagementDefault',
                    img:{
                        now: require('@/assets/img/component/bizMenu/setting.svg'),
                        default: require('@/assets/img/component/bizMenu/setting.svg'),
                        hover: require('@/assets/img/component/bizMenu/setting.svg')
                    },
                    title: '企業設置',
                    subDisplay: false,
                    children: [
                        {
                            linkName: 'bizBussinessVerified',
                            title: '認證資訊',
                            display: this.bizAuth?this.bizAuth.AuditCompany.hasRight:false
                        },
                        {
                            linkName: 'bizIntrolDefault',
                            title: '企業簡介',
                            display: this.bizAuth?this.bizAuth.companyIntroduction.hasRight:false
                        },
                        {
                            linkName: 'bizContractVersion',
                            title: '設定合約',
                            display: this.bizAuth?this.bizAuth.settingContract.hasRight:false
                        },
                        // {
                        //     linkName: 'bizContractVersion',
                        //     title: '合約版本',
                        //     display: true
                        // },
                        {
                            linkName: 'billChargeMode',
                            title: '費用設定',
                            display: true
                        },
                        {
                            linkName: 'bizWalletDefault',
                            title: '飛豬錢包',
                            display: this.bizAuth?this.bizAuth.viewWallet.hasRight:false
                        },
                        {
                            linkName: 'bizElectReceiptDefault',
                            title: '電子發票',
                            display: true
                            // display: this.bizAuth?this.bizAuth.electronicInvoiceEmail.hasRight:false
                        },
                    ]
                },
            ]
        },
        menuFilter: function () {
            this.componentKey
            return this.menuList.filter((item) => {
                for (let i = 0; i < item.children.length; i++) {
                    const subTitle = item.children[i];
                    // console.log(subTitle)
                    if(subTitle.display === true){
                        return item
                    }
                }
            });
        },
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
            todoHouseCount: 'BIZ_TODO_LIST_HOUSE_COUNT',
            todoBookingCount: 'BIZ_TODO_LIST_BOOKING_COUNT',
            todoContractCount: 'BIZ_TODO_LIST_CONTRACT_COUNT',
            todoTaskCount: 'BIZ_TODO_LIST_TASK_COUNT',
            hasTodo: 'BIZ_TODO_LIST_HAS_COUNT'
        })
    }
}
</script>
<style lang="scss">
    .biz-menu-mb{
        display: none;
        position: relative;;
        background: #fff;
        width: 186px;
        border-right: 1px solid #f0f0f0;
        height: 100%;
        text-align: center;
        z-index: 2;
        padding-right: 28px;
        // transition: 0.2s;
        .logo{
            width: 50px;
            height: 50px;
            // margin-top: 20px;
            // margin-bottom: 60px;
            margin: 20px auto 30px;
            // background: #F05A3E;
            border-radius: 10px;
            // border: solid 1px #ff9100;
        }
        >ul{
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-bottom: 150px;
            li{
                position: relative;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                flex-direction: column;
                cursor: pointer;
                // justify-content: center;
                .main-title{
                    width: 152px;
                    padding: 10px 0 10px 20px;
                    // transition: 0.2s;
                    display: flex;
                    align-items: center;
                    margin-bottom: 8px;
                    .list-icon{
                        margin-right: 10px;
                    }
                    .list-title{
                        opacity: 0.8;
                        color: #a8a5a4;
                        margin-right: 30px;
                    }
                    .list-arrow{
                        transform: rotate(180deg);
                        &.close{
                            transform: rotate(0deg);
                        }
                    }
                    .todo-dot{
                        left: 21px;
                        top: 12px;
                    }
                }
                // a.active,
                // a:hover{
                //     border-radius: 26.5px;
                //     background-color: #fff9f1;
                //     .list-title{
                //         opacity: 1;
                //         color: #292625;
                //         font-weight: 500;
                //     }
                // }
                .tip{
                    position: absolute;
                    background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgODQgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Q29tYmluZWQgU2hhcGU8L3RpdGxlPgogICAgPGcgaWQ9IuaIv+aFi+mmlumggSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuWwjuiIqi1ob3Zlci0xMjgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzQuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiMyMDIzMjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuMDAwMDAwLCAxMzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNODAsMCBDODIuMjA5MTM5LC00LjA1ODEyMjUxZS0xNiA4NCwxLjc5MDg2MSA4NCw0IEw4NCwzMiBDODQsMzQuMjA5MTM5IDgyLjIwOTEzOSwzNiA4MCwzNiBMOCwzNiBDNS43OTA4NjEsMzYgNCwzNC4yMDkxMzkgNCwzMiBMNCwyMS45MzggTDAuNSwxOCBMNCwxNC4wNjMgTDQsNCBDNCwxLjc5MDg2MSA1Ljc5MDg2MSw0LjA1ODEyMjUxZS0xNiA4LDAgTDgwLDAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
                    width: 84px;
                    height: 36px;
                    left: 53px;
                    top: 7px;
                    color: #fff;
                    display: none;
                    align-items: center;
                    justify-content: center;
                }
                >ul{
                    >li{
                        margin-bottom: 16px;
                        margin-left: -6px;
                        // cursor: pointer;
                        a,
                        span{
                            &.router-link-active,
                            &:hover{
                                color: #ff9275;
                            }
                        }
                        .todo-count{
                            right: 21px;
                            top: 1px;
                        }
                        
                    }
                }
            }
        }
    }
    @media screen and (max-width: 1280px) {
        .biz-menu-mb{
            display: block;
            width: 80px;
            text-align: center;
            padding-right: 0;
            .logo{
                width: 50px;
                height: 50px;
                // margin-top: 20px;
                // margin-bottom: 60px;
                margin: 10px auto 30px;
                // background: #F05A3E;
                border-radius: 10px;
                // border: solid 1px #ff9100;
            }
            >ul{
                position: relative;
                display: flex;
                flex-direction: column;
                align-items: center;
                margin-bottom: 150px;
                li{
                    position: relative;
                    right: -10px;
                    margin-bottom: 10px;
                    margin-right: 10px;
                    display: flex;
                    align-items: center;
                    flex-direction: column;
                    cursor: pointer;
                    // justify-content: center;
                    .main-title{
                        position: relative;
                        width: 40px;
                        height: 40px;
                        padding: 0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 4px;
                        margin-right: 10px;
                        &:hover{
                            background-color: #f6f6f6;
                        }
                        .list-icon{
                            margin-right: 0px;
                        }
                        .list-title{
                            display: none;
                        }
                        .list-arrow{
                            display: none;
                        }
                    }
                    // &:hover{
                    //     >ul{
                    //         display: block;
                    //     }
                    // }
                    // a.active,
                    // a:hover{
                    //     border-radius: 26.5px;
                    //     background-color: #fff9f1;
                    //     .list-title{
                    //         opacity: 1;
                    //         color: #292625;
                    //         font-weight: 500;
                    //     }
                    // }
                    // .tip{
                    //     position: absolute;
                    //     background: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iODRweCIgaGVpZ2h0PSIzNnB4IiB2aWV3Qm94PSIwIDAgODQgMzYiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8dGl0bGU+Q29tYmluZWQgU2hhcGU8L3RpdGxlPgogICAgPGcgaWQ9IuaIv+aFi+mmlumggSIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGcgaWQ9IuWwjuiIqi1ob3Zlci0xMjgwIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNzQuMDAwMDAwLCAtMTMxLjAwMDAwMCkiIGZpbGw9IiMyMDIzMjIiPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNzQuMDAwMDAwLCAxMzEuMDAwMDAwKSI+CiAgICAgICAgICAgICAgICA8cGF0aCBkPSJNODAsMCBDODIuMjA5MTM5LC00LjA1ODEyMjUxZS0xNiA4NCwxLjc5MDg2MSA4NCw0IEw4NCwzMiBDODQsMzQuMjA5MTM5IDgyLjIwOTEzOSwzNiA4MCwzNiBMOCwzNiBDNS43OTA4NjEsMzYgNCwzNC4yMDkxMzkgNCwzMiBMNCwyMS45MzggTDAuNSwxOCBMNCwxNC4wNjMgTDQsNCBDNCwxLjc5MDg2MSA1Ljc5MDg2MSw0LjA1ODEyMjUxZS0xNiA4LDAgTDgwLDAgWiIgaWQ9IkNvbWJpbmVkLVNoYXBlIj48L3BhdGg+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==);
                    //     width: 84px;
                    //     height: 36px;
                    //     left: 53px;
                    //     top: 7px;
                    //     color: #fff;
                    //     display: none;
                    //     align-items: center;
                    //     justify-content: center;
                    // }
                    >ul{
                        position: absolute;
                        width: 135px;
                        padding: 16px 1px 10px 5px;
                        box-sizing: border-box;
                        border-radius: 4px;
                        box-shadow: 0 2px 8px 0 rgba(41, 38, 37, 0.16);
                        background-color: #ffffff;
                        left: 45px;
                        &::before{
                            content: url('../../../../assets/img/component/bizMenu/menu_arrow.svg');
                            position: absolute;
                            left: -5px;
                            top: 10px;
                        }
                        .sub-title{
                            color: #a19d9c;
                            font-size: 12px;
                        }
                        >.sub-title,
                        >li{
                            margin-bottom: 16px;
                            margin-left: -45px;
                            // cursor: pointer;
                            a,
                            span{
                                &.router-link-active,
                                &:hover{
                                    color: #ff9275;
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/bussiness/widges/menu/bizMenuMb.vue